import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { APIServiceProvider } from "./../../common/services/api.service";

import { HelperServiceProvider } from "./../../common/services/helper.service";

import { TabOrder } from "./../orders/tabs/tab-order";

import { TabInventory } from "./../inventory/tabs/tab-inventory";

import { TabDelivered } from "./../orders/orderdeliveredtabs/tabs-delivered";

@Component({
  selector: "page-manager",
  templateUrl: "manager.html"
})
export class ManagerPage {
  public getUrl = "orders/get-subordinate-reports";
  public getCustomerUrl = "users/";

  public postParams = {
    manager_id: null,
    limit: 10
  };
  public results = [];
  public pagination = null;
  public searchText = null;

  public user_name: any = "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public helperService: HelperServiceProvider,
    public apiHelper: APIServiceProvider
  ) {}

  ionViewDidLoad() {
    this.postParams.manager_id = this.navParams.get("manager_id");
    console.log(this.postParams.manager_id);
    this.getManagerData(this.getUrl);
    this.getManagerInfo(this.getCustomerUrl + this.postParams.manager_id);
  }

  getManagerData(url, refresh?) {
    this.apiHelper.post(url, this.postParams).subscribe(response => {
      this.results = response["data"]["data"];

      this.pagination = response["data"];
      if (refresh) {
        refresh.complete();
      }
    });
  }

  navigateToAnother(user_id) {
    this.navCtrl.push(ManagerPage, { manager_id: user_id });
  }

  goToInventory(user_id) {
    this.setManagerData(user_id);
    this.navCtrl.push(TabInventory);
  }

  getManagerInfo(url) {
    this.apiHelper.get(url).subscribe(response => {
      this.user_name = response["data"]["user_name"];
    });
  }

  doRefresh(refresher) {
    this.getManagerData(this.getUrl, refresher);
  }

  doInfiniteScroll(event) {
    if (
      !this.pagination.next_page_url ||
      this.pagination.next_page_url === "" ||
      this.pagination.next_page_url === null ||
      this.pagination.next_page_url === "null"
    ) {
      event.complete();
      return;
    } else {
      this.apiHelper
        .post(null, this.postParams, this.pagination["next_page_url"])
        .subscribe(response => {
          this.results = this.results.concat(response["data"]["data"]);
          this.pagination = response["data"];
          event.complete();
        });
      return;
    }
  }

  setManagerData(user_id) {
    localStorage.setItem("manager_user_id", user_id);
  }

  goToCashNotSubmitted(user_id) {
    let self = this;

    this.setManagerData(user_id);

    this.navCtrl.push(TabDelivered);

    setTimeout(function() {
      self.navCtrl.getActiveChildNav().select(0);
    }, 100);
  }

  goToCashPending(user_id) {
    let self = this;

    this.setManagerData(user_id);

    this.navCtrl.push(TabDelivered);

    setTimeout(function() {
      self.navCtrl.getActiveChildNav().select(1);
    }, 100);
  }

  goToCashSettled(user_id) {
    let self = this;

    this.setManagerData(user_id);

    this.navCtrl.push(TabDelivered);

    setTimeout(function() {
      self.navCtrl.getActiveChildNav().select(2);
    }, 100);
  }

  goToPlaced(user_id) {
    let self = this;

    this.setManagerData(user_id);

    this.navCtrl.push(TabOrder);

    setTimeout(function() {
      self.navCtrl.getActiveChildNav().select(0);
    }, 100);
  }

  goToDispatched(user_id) {
    let self = this;

    this.setManagerData(user_id);

    this.navCtrl.push(TabOrder);

    setTimeout(function() {
      self.navCtrl.getActiveChildNav().select(1);
    }, 100);
  }

  goToReceived(user_id) {
    let self = this;

    this.setManagerData(user_id);

    this.navCtrl.push(TabOrder);

    setTimeout(function() {
      self.navCtrl.getActiveChildNav().select(2);
    }, 100);
  }
}



// WEBPACK FOOTER //
// ./src/pages/manager/manager.ts